import {
    RangePickerOption,
    TimeRange,
    PilotTrackingRangePicker,
    PilotTrackingPlatformTimeChart,
} from "@nova/component-charts"
import classNames from "classnames"
import { useState, useMemo } from "react"
import { Card } from "../MetricLayout"
import { usePlatformMetrics } from "./usePlatformMetrics"

const platformTimeRangeOptions: RangePickerOption<TimeRange>[] = [
    { title: "30 days", value: "30d" },
    { title: "6 months", value: "6m" },
    { title: "1 year", value: "1y" },
]
export const PlatformActivityCard = ({ userId }: { userId: string }) => {
    const [range, setRange] = useState<TimeRange>("1y")
    const { byDay, total, isLoading } = usePlatformMetrics({ pilotId: userId, timeRange: range })

    const data = useMemo(
        () =>
            ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map((day, i) => ({
                label: day,
                value: byDay?.[(i + 1) % 7] ?? 0, // backend indices start on sunday
            })),
        [byDay]
    )

    return (
        <Card className="w-full h-full flex gap-8 py-8 px-8 flex-col bg-white-100 min-w-0">
            <div className="flex flex-col gap-1">
                <h5 className="text-gray-400">Platform Time</h5>
                <div className="flex items-center justify-between">
                    <h2
                        className={classNames(
                            "text-gray-0 transition-opacity duration-400 telegraf",
                            {
                                "opacity-20": isLoading,
                            }
                        )}
                    >
                        {total?.toFixed(2) ?? "0.00"} hours
                    </h2>
                    <PilotTrackingRangePicker
                        options={platformTimeRangeOptions}
                        value={range}
                        onChange={(v) => !isLoading && setRange(v.value)}
                    />
                </div>

                <div className="h-[250px] w-full flex items-center justify-center relative">
                    <PilotTrackingPlatformTimeChart
                        data={data}
                        height={250}
                        barOpacity={isLoading ? 0.2 : 1}
                    />
                </div>
            </div>
        </Card>
    )
}
